import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  dialPad: {
    number: null,
    numberDialed: null,
    callInProgress: true,
  },
  isLoggedInToAWS: false,
}

const appStateSlice = createSlice({
  name: 'appState',
  initialState,
  reducers: {
    setDialPad(state, { payload }) {
      state.dialPad.number = payload?.number
    },
    setCallInProgress(state, { payload }) {
      state.dialPad.callInProgress = payload?.callInProgress
    },
    setDialPadNumberDialed(state, { payload }) {
      state.dialPad.numberDialed = payload?.numberDialed
    },
    setIsLoggedInToAWS(state, { payload }) {
      state.isLoggedInToAWS = payload
    },
  },
})

export const {
  setDialPad,
  setCallInProgress,
  setDialPadNumberDialed,
  setIsLoggedInToAWS,
} = appStateSlice.actions

export default appStateSlice.reducer
